import { keepPreviousData } from '@tanstack/react-query';

import {
  asyncTasksQueryKeys,
  getAsyncTasks,
  type AsyncTasksListParams,
  type AsyncTasksListResponse,
} from '@api/asyncTasks';
import { createResourceListInfiniteQuery } from '@hooks/resourceListPage';

const useAsyncTasksInfiniteQuery = createResourceListInfiniteQuery<
  AsyncTasksListResponse,
  AsyncTasksListParams
>({
  queryKey: (params) => asyncTasksQueryKeys.list(params),
  fetcher: getAsyncTasks,
  placeholderData: keepPreviousData,
});

interface UseAsyncTasksOptions {
  enabled?: boolean;
}

export function useAsyncTasks(
  params?: AsyncTasksListParams,
  { enabled = true }: UseAsyncTasksOptions = {}
) {
  return useAsyncTasksInfiniteQuery({ params, enabled });
}
